import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Noticias.css';

const Noticias = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get('https://api.mediastack.com/v1/news', {
          params: {
            access_key: '3c9f586f10adb2c53d9ed044daf49c0b', // Reemplaza con tu clave de API
            categories: 'technology, general', // Comentamos esta l??nea para hacer la b??squeda m??s amplia
            // keywords: '', // Tambi??n comentamos las palabras clave
            countries: 'es', //paises
            languages: 'es', // Idioma espa??ol
            sort: 'published_desc',
            limit: 35
          }
        });

        // Revisamos la respuesta en la consola
        console.log('API Response:', response.data);

        if (response.data && response.data.data) {
          setNews(response.data.data);
        } else {
          setError("No se encontraron noticias.");
        }
      } catch (error) {
        console.error("Error fetching the news:", error.message);
        setError("Hubo un error al obtener las noticias.");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <div>
      <header className="header">
        Noticias Dhoy
      </header>

      {loading ? (
        <p>Cargando noticias...</p>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <div className="news-list">
          {news.length > 0 ? (
            news.map((article, index) => (
              <div key={index} className="news-item">
                {article.image && (
                  <img src={article.image} alt={article.title} />
                )}
                <h2>{article.title}</h2>
                <p>{article.description}</p>
                <a href={article.url} target="_blank" rel="noopener noreferrer">
                  Leer m??s
                </a>
              </div>
            ))
          ) : (
            <p>No hay noticias disponibles en este momento.</p>
          )}
        </div>
      )}

      <footer className="footer">
        &copy; jtejero8
      </footer>
    </div>
  );
};

export default Noticias;
